/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React from 'react'
import Button from 'components/commons/button'

const ArchiveDialog = ({ onSubmit, onClose, ...props }: any) => {
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='border-0 shadow-lg relative flex flex-col w-full bg-white rounded-lg outline-none focus:outline-none'>
            <div className='relative px-8 pt-8 flex-auto space-y-6'>
              <div className='flex flex-col justify-center text-center space-y-6'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-14 h-14 -m-1 flex items-center text-red-500 mx-auto'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  ></path>
                </svg>
                <h1 className='font-bold text-xl'>Are you sure?</h1>
                <p>Do you want to archive this collection?</p>
              </div>
              {props.children}
            </div>
            <div className='flex flex-row justify-center items-center p-8 border-slate-200 rounded-b space-x-4'>
              <Button
                onClick={() => onClose('archive-dialog')}
                className='bg-gray-200 font-semibold border px-6'
              >
                Cancel
              </Button>
              <Button
                onClick={onSubmit}
                className='border border-red-500 bg-red-500 text-white font-semibold px-6'
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </>
  )
}

export default ArchiveDialog
